var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgOrderedList = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "inherit",
  className: "orderedList_svg__safari-svg-fix",
  viewBox: "0 0 20 20",
  "aria-hidden": props["aria-label"] || props["aria-labelledby"] ? undefined : true
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M2.083 13.333H3.75v.417h-.833v.833h.833V15H2.083v.833h2.5V12.5h-2.5zM2.917 7.5h.833V4.167H2.083V5h.834zm-.834 1.666h1.5l-1.5 1.75v.75h2.5v-.833h-1.5l1.5-1.75v-.75h-2.5zM6.25 5v1.667h11.667V5zm0 10h11.667v-1.667H6.25zm0-4.167h11.667V9.166H6.25z"
})));
export default SvgOrderedList;